import { useNavigate } from 'react-router-dom';

import { formatDate } from 'helpers/dates-formatter';

import type { InsightSummary } from 'containers/user/insights/use-insights';

interface InsightItemProps {
  insight: InsightSummary;
}

const DEFAULT_DESCRIPTION_MAX_LENGTH = 100;

const InsightItem = ({ insight }: InsightItemProps): React.JSX.Element => {
  const navigate = useNavigate();

  const handleClick = (): void => {
    navigate(`/insights/${insight.id}`);
  };

  const truncateDescription = (
    text: string | undefined,
    maxLength: number = DEFAULT_DESCRIPTION_MAX_LENGTH
  ): string => {
    if (!text) return '';
    if (text.length <= maxLength) return text;

    return text.substring(0, maxLength) + '...';
  };

  return (
    <button
      onClick={handleClick}
      className="bg-navy-50 px-5 py-4 rounded-md w-72 min-h-28 flex flex-col justify-between border border-navy-100 text-left cursor-pointer relative"
    >
      {!insight.viewed && (
        <div className="absolute top-3 right-3 w-2 h-2 bg-critical-500 rounded-full"></div>
      )}
      <div className="flex flex-col">
        <div className="font-bold mb-1 text-left text-gray-700">
          {insight.name}
        </div>

        {insight.description && (
          <p className="text-sm text-gray-700 mb-3">
            {truncateDescription(insight.description)}
          </p>
        )}
      </div>

      <div className="text-xs text-gray-600 mt-auto">
        <div className="font-semibold">
          {formatDate(insight.createdDate, 'MMMM D, YYYY')}
        </div>
        <div>
          Created by:{' '}
          <span className="font-semibold">
            {insight.createdBy || 'Unknown'}
          </span>
        </div>
      </div>
    </button>
  );
};

export default InsightItem;
